<template>
  <div>
    <Modal
      :open="open"
      @close="close($t(`cs.analysis.carePossibility.modal-${id}.headline`), 'element')"
      size="m"
    >
      <template v-if="id">
        <Headline size="m">
          {{ $t(`cs.analysis.carePossibility.modal-${id}.headline`) }}
        </Headline>
        <Copy>
          <span
            v-html="
              $t(`cs.analysis.carePossibility.modal-${id}.copy`, {
                careLevel: facts.pflegegrad,
                money: facts.pflegegeld + facts.entlastungsbetrag,
              })
            "
          />
        </Copy>
        <div class="u-margin__vertical--4">
          <Row>
            <Col :xs="12" :m="6" :hasMargin="!$matchMedia.l">
              <ToggleTeaser
                :headline="$t('cs.analysis.carePossibility.modal.pflegegeld.headline')"
                :copy="$t('cs.analysis.carePossibility.modal.pflegegeld.copy')"
                :priceSmall="facts.pflegegeld * 12"
                :priceBig="facts.pflegegeld"
              />
            </Col>
            <Col :xs="12" :m="6" :hasMargin="!$matchMedia.l">
              <ToggleTeaser
                :headline="$t('cs.analysis.carePossibility.modal.entlastungsbetrag.headline')"
                :copy="[
                  $t('cs.analysis.carePossibility.modal.entlastungsbetrag.copy1'),
                  $t('cs.analysis.carePossibility.modal.entlastungsbetrag.copy2'),
                ]"
                :priceSmall="facts.entlastungsbetrag * 12"
                :priceBig="facts.entlastungsbetrag"
              />
            </Col>
          </Row>
        </div>

        <TableRow>
          <Headline slot="left" size="s" noMargin>
            {{ $t('cs.analysis.carePossibility.modal.example.headline') }}
          </Headline>
          <strong slot="right">
            {{ $t('cs.analysis.carePossibility.modal.example.perMonth') }}
          </strong>
        </TableRow>

        <TableMaintenance v-if="id === 1" :facts="facts" />
        <TableHours v-if="id === 2" :facts="facts" />

        <SimpleTeaser
          :headline="$t(`cs.analysis.carePossibility.modal-${id}.bottomTeaser.headline`)"
          :copy="$t(`cs.analysis.carePossibility.modal-${id}.bottomTeaser.copy`)"
          :button="{
            label: $t(`cs.analysis.carePossibility.modal-${id}.bottomTeaser.linkText`),
          }"
          :href="$t(`cs.analysis.carePossibility.modal-${id}.bottomTeaser.linkHref`)"
          external
          direction="horizontal"
          background="secondaryRose"
          class="u-margin__vertical--3"
          :clickOnTeaserLink="
            () =>
              trackClick(
                '-Betreuungsmöglichkeiten-Sheet_link-Weitere Informationen_' +
                  $t(`cs.analysis.carePossibility.modal-${id}.headline`)
              )
          "
        />

        <Row class="u-padding__vertical--3">
          <Col :xs="12" right>
            <Button
              label="Schließen"
              type="outlined"
              @click="close($t(`cs.analysis.carePossibility.modal-${id}.headline`), 'button')"
            />
          </Col>
        </Row>
      </template>
    </Modal>

    <Row>
      <Col :xs="12" :l="6" :hasMargin="!$matchMedia.l">
        <SimpleTeaser
          :headline="$t('cs.analysis.carePossibility.teaser1.headline')"
          :copy="$t('cs.analysis.carePossibility.teaser1.copy')"
          :button="{
            label: $t('cs.analysis.carePossibility.teaser1.button'),
            onClick: () => onClick(1),
          }"
        />
      </Col>
      <Col :xs="12" :l="6" :hasMargin="!$matchMedia.l">
        <SimpleTeaser
          :headline="$t('cs.analysis.carePossibility.teaser2.headline')"
          :copy="$t('cs.analysis.carePossibility.teaser2.copy')"
          :button="{
            label: $t('cs.analysis.carePossibility.teaser2.button'),
            onClick: () => onClick(2),
          }"
        />
      </Col>
    </Row>
  </div>
</template>

<script>
import Headline from '@/objects/Headline';
import Button from '@/objects/Button';
import Copy from '@/objects/Copy';
import Modal from '@/components/Modal';
import ToggleTeaser from '@/components/ToggleTeaser';
import SimpleTeaser from '@/components/SimpleTeaser';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';

import { formatNumber } from '@/helpers/formatter';

import careServiceFacts from '@/content/services/CareService/CareServiceFacts';

import TableRow from './TableRow';
import TableHours from './TableHours';
import TableMaintenance from './TableMaintenance';

import { mapFieldsCareService } from '@/store/mapFields';

export default {
  name: 'CarePossibility',
  props: {
    number: Number,
    plainHeadline: String,
  },
  components: {
    Headline,
    Button,
    Copy,
    Modal,
    ToggleTeaser,
    SimpleTeaser,
    Row,
    Col,
    TableRow,
    TableHours,
    TableMaintenance,
  },
  computed: {
    ...mapFieldsCareService(['careServiceCareLevel']),
  },
  data() {
    return {
      facts: null,
      formatNumber,
      id: null,
      open: false,
      el: 'c-careServiceResult',
    };
  },
  created() {
    this.facts = careServiceFacts.filter((c) => c.pflegegrad === this.careServiceCareLevel)[0];
  },
  methods: {
    onClick(newId) {
      this.id = newId;
      this.open = true;
      this.$emit(
        'onTrackingClick',
        '-Betreuungsmöglichkeiten_btn-' +
          this.$t('cs.analysis.carePossibility.teaser' + newId + '.button') +
          '_' +
          this.$t('cs.analysis.carePossibility.teaser' + newId + '.headline'),
        'button'
      );
    },

    close(sheetInfo, element) {
      this.open = false;
      this.trackClick(
        '-Betreuungsmöglichkeiten-Sheet_' +
          (element === 'button' ? 'btn' : 'click-X') +
          '-Schließen_' +
          sheetInfo,
        element
      );
    },

    trackClick(labelText, element = 'link') {
      labelText = labelText.replace('Beispiel für eine ', '');
      this.$emit('onTrackingClick', labelText, element);
    },
  },
};
</script>
